import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { invalidateLocalityCache, useAddLocality } from '../../../api/localities'
import { LocalityForm } from '../../../forms/LocalityForm'
import { ILocality } from '../../../generated-types'
import { ShowDialogProps } from '../../../show-dialog'
import { handleLocalityErrorResponse } from '../../localities/utils'

interface CreateLocalitiesProps extends ShowDialogProps {
  customerId: EntityId
}

export const CreateLocalitiesDialog: React.FC<CreateLocalitiesProps> = ({ pop, customerId }) => {
  const { t: translate } = useTranslation(['admin-locality', 'common'])
  const { mutateAsync, isLoading } = useAddLocality(customerId)

  const onSubmit = async (form: ILocality) => {
    await mutateAsync(form, {
      onSuccess: () => {
        toast.success(translate('addedSuccessfully', { ns: 'common' }))
        invalidateLocalityCache.getLocalities(customerId)
        invalidateLocalityCache.CustomerLocalitiesWithGroups(customerId)
        invalidateLocalityCache.getGroupedLocalitiesWithInfoCount(customerId)
        invalidateLocalityCache.getLocalitiesWithInfoCount(customerId)
        pop()
      },
      onError: (error: any) => {
        handleLocalityErrorResponse(error.data.message)
      },
    })
  }

  return (
    <LocalityForm
      title={translate('addLocality', { ns: 'admin-locality' })}
      isLoading={isLoading}
      onSubmit={onSubmit}
      customerId={customerId as number}
      onCancel={() => pop()}
    />
  )
}
